import Swiper, { Navigation, Pagination } from 'swiper';
import 'swiper/css';
import { domContentLoadEvent } from '../common/domContentLoadEvent';

function initializeDifferentials(featuresElement) {
    const swiperPagination = featuresElement.querySelector('.swiper-pagination');

    new Swiper(featuresElement.querySelector('.swiper'), {
        modules: [Pagination, Navigation],
        slidesPerView: 1,
        loop: true,
        pagination: {
            el: swiperPagination,
            clickable: true,
        },
        navigation: {
            nextEl: '.features-carousel .swiper-button-next',
            prevEl: '.features-carousel .swiper-button-prev',
        },
    });
}

function initializeAllDifferentials() {
    document.querySelectorAll('.features-carousel').forEach(function (element) {
        initializeDifferentials(element);
    });
}

domContentLoadEvent(initializeAllDifferentials);
